import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFormatUppercase = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 21,
	fill: "none",
	viewBox: "0 0 20 21",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M1.75 16.25 5.5 5.75l3.75 10.5M3 12.75h5M14.773 11c1.477 0 2.477-1 2.477-2.625 0-1.375-1-2.625-2.477-2.625H12.25c-.25 0-.5.25-.5.5V11m3.023 0h.954c1.523 0 2.523 1.25 2.523 2.5 0 1.5-1 2.75-2.523 2.75H12.25c-.25 0-.5-.25-.5-.5V11m3.023 0H11.75"
	})]
});
const ForwardRef = forwardRef(SvgFormatUppercase);
export { ForwardRef as ReactComponent };
